import React from "react";
import { 
  Image,
  Row,
  Col,
  Container,
  Button,
} from 'react-bootstrap';
import Translate from "../../../../../../../translate";
import "./BannerApi.css";
import BannerLaptop from "../../../../../img/BannerApi_LaptopCripto.png";
import Planta from "../../../../../img/BannerApi_PlantaRayo.png";
import ApiMobile from "../../../../../img/banner-api-mobile.png";

const BannerApi = ({lan}) => {

  return (
    <div className='comisiones-outter'>
      <div className="img-api">
        <Image src={BannerLaptop} className='floating-lap'/>
        <Image src={Planta} className='planta'/>
        <Image src={ApiMobile} className='floating-lap-mobile'/>
      </div>
      <Container>
        <Row>
          <Col xl={7} lg={6}>
            <p>
              <span className="banner-api-title">{Translate[lan].landing3.banner.api.titulo}</span>
                <br/>
              <span className="banner-api-subtitle">
                {Translate[lan].landing3.banner.api.subtitulo}
              </span>
            </p>
            <div className="align-mobile-btn">
              <Button
                className='main-button'
                onClick={()=>window.open(window.location.origin + '/register','_blank')}
              >
                {Translate[lan].landing3.banner.button1}
              </Button>
            </div>
          </Col>
        </Row>
      </Container>
    </div>
  )
}

export default BannerApi;